import type { LucideIcon } from "lucide-react";
import { X } from "lucide-react";
import type React from "react";
import { BasicModal } from "@/components/common/BasicModal";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface SettingsModalLayoutProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  icon: LucideIcon;
  children: React.ReactNode;
  footer?: React.ReactNode;
  maxWidth?: string;
  closeDisabled?: boolean;
  containerClassName?: string;
  bodyClassName?: string;
}

export const SettingsModalLayout: React.FC<SettingsModalLayoutProps> = ({
  isOpen,
  onClose,
  title,
  icon: Icon,
  children,
  footer,
  maxWidth = "max-w-md",
  closeDisabled = false,
  containerClassName,
  bodyClassName,
}) => {
  return (
    <BasicModal
      isOpen={isOpen}
      onClose={onClose}
      maxWidth={maxWidth}
      showCloseButton={false}
      title={title}
    >
      <div
        className={cn(
          "flex flex-col overflow-hidden rounded-lg bg-white",
          containerClassName,
        )}
      >
        <div className="flex items-center justify-between border-b p-6">
          <div className="flex items-center gap-2">
            <Icon className="size-5" />
            <h2 className="text-xl font-semibold">{title}</h2>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClose}
            disabled={closeDisabled}
          >
            <X className="size-4" />
          </Button>
        </div>

        <div className={cn("flex-1 overflow-y-auto p-6", bodyClassName)}>
          {children}
        </div>

        {footer}
      </div>
    </BasicModal>
  );
};
